/**
 * My API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ReportCurrentPrevious } from './reportCurrentPrevious';


export interface ReportVibrationAverageStats { 
    bearing_spindle?: ReportCurrentPrevious;
    vibration_level?: ReportCurrentPrevious;
    asset_health_indicator?: ReportCurrentPrevious;
    vibration_frame?: ReportCurrentPrevious;
    bearing_motor?: ReportCurrentPrevious;
    bearing_liquid_side?: ReportCurrentPrevious;
    bearing_solid_side?: ReportCurrentPrevious;
    motor_plate?: ReportCurrentPrevious;
}

